export class ReceptionFlag {
  constructor(
    public labelName: string,
    public value: boolean,
  ) {
  }
}
